import { z } from 'zod';

export const loginSchema = z.object({
  email: z.string().email('Invalid email address'),
  password: z.string().min(6, 'Password must be at least 6 characters'),
});

export const registerSchema = z
  .object({
    username: z.string().min(3, 'Username must be at least 3 characters'),
    email: z.string().email('Invalid email address'),
    password: z.string().min(6, 'Password must be at least 6 characters'),
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords don't match",
    path: ['confirmPassword'],
  });

export const magicLinkSchema = z.object({
  email: z.string().email('Invalid email address'),
});

export const verifyCodeSchema = z.object({
  code: z.string().length(6, 'Verification code must be 6 digits'),
});

export type LoginFormData = z.infer<typeof loginSchema>;
export type RegisterFormData = z.infer<typeof registerSchema>;
export type MagicLinkFormData = z.infer<typeof magicLinkSchema>;
export type VerifyCodeFormData = z.infer<typeof verifyCodeSchema>;
